import { createEvent, forward, restore } from 'effector-root'
import { createFiltersModel } from '@/pages/common/filters/create-filters-model'
import { dropdownModules } from '@/pages/learning/learning-courses/list/parts/filter/parts/dropdown-modules'
import { subjectsDropdownModel } from '@/pages/common/dropdowns/multiselectDropdown/subject-dropdown-filter/subject-filter-dropdown.model'
import { classesDropdownModel } from '@/pages/common/dropdowns/multiselectDropdown/classes-dropdown-filter/classes-filter-dropdown.model'
import { groupsDropdownModel } from '@/pages/common/dropdowns/multiselectDropdown/groups-dropdown-filter/groupsFilterDropdown.model'

export const coursesFilters = createFiltersModel({}, dropdownModules)

export const reset = createEvent<void>()

export const toggleVisibility = createEvent<boolean>()
export const $visibility = restore(toggleVisibility, false).reset(reset)

export const toggleWithClasses = createEvent<boolean>()
export const $withClasses = restore(toggleWithClasses, false).reset(reset)

export const toggleWithNoClasses = createEvent<boolean>()
export const $withNoClasses = restore(toggleWithNoClasses, false).reset(reset)

forward({
  from: reset,
  to: [
    classesDropdownModel.methods.resetSelectedItems,
    subjectsDropdownModel.methods.resetSelectedItems,
    groupsDropdownModel.methods.resetSelectedItems,
  ],
})
